"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var defaults = {
  invoiceId: null,
  amountDue: null,
  dueDate: null,
  currency: null,
  status: null,
  customerName: null,
  invoiceLink: null
};

var AccountingInvoiceSummary =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(AccountingInvoiceSummary, _Record);

  function AccountingInvoiceSummary() {
    (0, _classCallCheck2.default)(this, AccountingInvoiceSummary);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccountingInvoiceSummary).apply(this, arguments));
  }

  (0, _createClass2.default)(AccountingInvoiceSummary, [{
    key: "invoiceTitle",
    value: function invoiceTitle() {
      return "#" + this.invoiceId + " - " + this.customerName;
    }
  }, {
    key: "isPaid",
    value: function isPaid() {
      return this.status === 'PAID';
    }
  }, {
    key: "isOverdue",
    value: function isOverdue() {
      return _I18n.default.moment().valueOf() > this.dueDate;
    }
  }]);
  return AccountingInvoiceSummary;
}((0, _immutable.Record)(defaults));

var _default = AccountingInvoiceSummary;
exports.default = _default;
module.exports = exports.default;